import { Button, Grid, Paper, Box, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import {
    createRoomDoctor,
    deleteRoomDoctor,
    getDoctorSchedule,
    getRoomDoctor,
    updateRoomDoctor,
} from "../../../../api/assignDoctorApi";
import { getAllRoomDoctor, getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import Color from "../../../../styles/Color";
import {
    initialRoomTableOptions,
    roomTableColumns,
    initialRoomValues,
} from "../assign_build/helpers/AssignBuildEvtOption";

import FilterData from "./components/FilterData";
import FormAssignDoc from "./components/FormAssignDoc";
import {
    initialRoomDoctorTableOptions,
    initialValueFormAssignDoc,
    roomDoctorTableColumns,
} from "./helpers/assignDoctorOption";
import { useSelector } from "react-redux";

export default function AssignDoctor() {
    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [changePage, setchangePage] = useState(0);
    const [isOpenModalAdd, setIsOpenModalAdd] = useState(false);
    const [tableOptions, setTableOptions] = useState(initialRoomTableOptions);
    const [option, setOption] = useState({ building: [], floor: [] });
    const [selectBuilding, setSelectBuilding] = useState();
    const [selectFloor, setSelectFloor] = useState();
    const [tableOptionsDoctor, setTableOptionsDoctor] = useState(initialRoomDoctorTableOptions);
    const [roomID, setRoomID] = useState(0);
    const [doctorDetail, setdoctorDetail] = useState();
    const [initialValueFormDoc, setinitialValueFormDoc] = useState(initialValueFormAssignDoc);

    // fetch building setting option
    const fetchBuildingSettingOption = useCallback(async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // handle function Delete Data Table
    const handleDelete = useCallback(async (e, data) => {
        Swal.fire({
            heightAuto: false,
            icon: "warning",
            iconColor: Color.primary,
            title: '<div class="h3 t-text-primary">Are you delete?</div>',
            text: "",
            showCancelButton: true,
            confirmButtonColor: Color.primary,
            cancelButtonColor: "#7C7C7C",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
        }).then(async result => {
            if (result.isConfirmed === true) {
                const isDelete = await deleteRoomDoctor(data?.roomDoctorId, controllerRef.current?.signal);
                if (isDelete) {
                    tableRef.current.onQueryChange();
                    setIsOpenModalAdd(false);
                }
            }
        });
    }, []);

    // open edit form
    const handleOpenEditForm = useCallback(async doctor => {
        setchangePage(1);
        setRoomID(doctor?.roomId);
    }, []);

    // open modal form
    const handleOpenEditFormModal = useCallback(async value => {
        setIsOpenModalAdd(true);
        setinitialValueFormDoc({
            codeDoc: value?.doctorCode || "",
            days: JSON.parse(value?.dayRoom) || [],
            period: value?.moment || "",
            roomDoctorId: value?.roomDoctorId || "",
        });
    }, []);

    const handleCancel = useCallback(async () => {
        setchangePage(0);
        setinitialValueFormDoc(initialValueFormAssignDoc);
    }, []);

    // close modal
    const handleCloseModal = useCallback(() => {
        setIsOpenModalAdd(false);
    }, []);

    // fetch data
    const fetchData = useCallback(
        async query => {
            try {
                const queryParams = {
                    page: query?.page + 1 || 1,
                    limit: query?.pageSize || 10,
                    search: query?.search || "",
                    order: query?.orderBy?.field || "roomId",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    buildingId: selectBuilding || "",
                    floorId: selectFloor || "",
                };
                const res = await getAllRoomDoctor(queryParams, controllerRef.current?.signal);
                if (res) {
                    setTableOptions(currentState => ({
                        ...currentState,
                        currentPage: query?.page,
                        pageSize: query?.pageSize || 10,
                        totalData: res?.pagination?.totalData || 0,
                        order: query?.orderBy?.field || "roomId",
                        direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    }));
                    return {
                        data: res?.data || [],
                        page: query?.page || 0,
                        totalCount: res?.pagination?.totalData || 0,
                    };
                }
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            } catch (error) {
                console.dir(error);
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            }
        },
        [selectBuilding, selectFloor],
    );

    // fech data Doctor
    const fetchDataDoctor = useCallback(
        async query => {
            try {
                const queryParams = {
                    page: query?.page + 1 || 1,
                    limit: query?.pageSize || 10,
                    search: query?.search || "",
                    order: query?.orderBy?.field || "roomDoctorId",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    roomId: roomID || 0,
                };
                const res = await getRoomDoctor(queryParams, controllerRef.current?.signal);
                if (res) {
                    setTableOptionsDoctor(currentState => ({
                        ...currentState,
                        currentPage: query?.page,
                        pageSize: query?.pageSize || 10,
                        totalData: res?.pagination?.totalData || 0,
                        order: query?.orderBy?.field || "roomDoctorId",
                        direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    }));
                    return {
                        data: res?.data || [],
                        page: query?.page || 0,
                        totalCount: res?.pagination?.totalData || 0,
                    };
                }
            } catch (error) {
                console.dir(error);
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            }
        },
        [roomID],
    );

    // create room doctor
    const handleCreateRoomDoctor = useCallback(
        async (value, { resetForm }) => {
            try {
                const createBody = {
                    roomId: roomID,
                    doctorCode: value?.codeDoc,
                    dayRoom: JSON.stringify(value?.days),
                    moment: value?.period,
                };
                const isCreateDoctor = await createRoomDoctor(createBody, controllerRef.current?.signal);
                if (isCreateDoctor) {
                    resetForm();
                    tableRef.current.onQueryChange();
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [roomID],
    );

    // fetch doctor data
    const fetchDoctorSchedule = useCallback(async () => {
        try {
            const res = await getDoctorSchedule(controllerRef.current?.signal);
            const doctor = res?.map(val => ({
                Doctorcode: val?.Doctorcode || "",
                Doctorname: val?.Doctorname || "",
            }));
            setdoctorDetail(doctor);
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // select building
    const handleSelectBuilding = useCallback(
        async (values, setFieldValue) => {
            if (values === "") {
                setSelectFloor(undefined);
            }
            if (changePage !== 0) {
                setchangePage(0);
            }
            await setFieldValue("floorId", "");
            await setFieldValue("buildingId", values);
            setSelectBuilding(values);
            tableRef.current.onQueryChange();
        },
        [changePage],
    );

    // select floor
    const handleSelectFloor = useCallback(
        async (values, setFieldValue) => {
            if (changePage !== 0) {
                setchangePage(0);
            }
            await setFieldValue("floorId", values);
            setSelectFloor(values);
            tableRef.current.onQueryChange();
        },
        [changePage],
    );

    // update room doctor logic
    const handleUpdateRoomDoctor = useCallback(
        async value => {
            try {
                const updateBody = {
                    roomId: roomID,
                    doctorCode: value?.codeDoc,
                    dayRoom: JSON.stringify(value?.days),
                    moment: value?.period,
                };
                const isUpdateUser = await updateRoomDoctor(
                    value?.roomDoctorId,
                    updateBody,
                    controllerRef.current?.signal,
                );
                if (isUpdateUser) {
                    tableRef.current.onQueryChange();
                    setIsOpenModalAdd(false);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [roomID],
    );

    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            await fetchBuildingSettingOption(controllerRef.current?.signal);
            await fetchDoctorSchedule();
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchBuildingSettingOption, fetchDoctorSchedule]);

    return (
        <Grid container spacing={2}>
            {/* filter */}
            <Grid item xs={12} className="mb-5">
                <FilterData
                    handleSelectBuilding={handleSelectBuilding}
                    handleSelectFloor={handleSelectFloor}
                    initialFormValues={initialRoomValues}
                    isCreateForm
                    buildingOption={option?.building}
                    floorOption={option?.floor}
                    handleCancel={handleCancel}
                />
            </Grid>

            <Grid item xs={12}>
                {/* Table Doctor */}
                <Paper className="t-table-custom p-lg-10 p-5">
                    {/* Room */}
                    {changePage === 0 && (
                        <MaterialTable
                            tableRef={tableRef}
                            title=""
                            components={{ Container: Box }}
                            data={fetchData}
                            options={tableOptions}
                            columns={roomTableColumns}
                            actions={[
                                {
                                    icon: "edit",
                                    iconProps: { style: { fontSize: 18 }, className: "action-edit" },
                                    tooltip: "Edit",
                                    onClick: (event, rowData) => handleOpenEditForm(rowData),
                                },
                            ]}
                        />
                    )}
                    {/* Doctor In Room */}
                    {changePage === 1 && (
                        <>
                            <div className="col-4 col-md-2 col-lg-1 mb-3" onClick={handleCancel}>
                                <Button className="t-btn-gray w-100">Back</Button>
                            </div>
                            {/* form */}
                            {thisMenuPermission?.create && (
                                <FormAssignDoc
                                    handleCancel={handleCancel}
                                    onSubmit={handleCreateRoomDoctor}
                                    doctorDetail={doctorDetail}
                                    initialValueFormDoc={initialValueFormDoc}
                                />
                            )}
                            <Grid container spacing={0}>
                                {/* table */}
                                <Grid item xs={12}>
                                    <div className="">
                                        <MaterialTable
                                            tableRef={tableRef}
                                            title=""
                                            components={{ Container: Box }}
                                            data={fetchDataDoctor}
                                            options={tableOptionsDoctor}
                                            columns={roomDoctorTableColumns}
                                            actions={[
                                                {
                                                    icon: "edit",
                                                    iconProps: { style: { fontSize: 18 }, className: "action-edit" },
                                                    tooltip: "Edit",
                                                    onClick: (event, rowData) => handleOpenEditFormModal(rowData),
                                                    hidden: !thisMenuPermission?.edit,
                                                },
                                                {
                                                    icon: "delete",
                                                    iconProps: { style: { fontSize: 18 }, className: "action-delete" },
                                                    tooltip: "Delete",
                                                    onClick: (event, rowData) => {
                                                        // Do save operation
                                                        handleDelete(event, rowData);
                                                    },
                                                    hidden: !thisMenuPermission?.delete,
                                                },
                                            ]}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Paper>
            </Grid>

            {/* Modal */}
            <Grid item xs={12}>
                <Modal scrollable centered show={isOpenModalAdd} size="xl" onHide={handleCloseModal}>
                    <Modal.Header>
                        <Modal.Title>Edit Doctor</Modal.Title>
                        <IconButton onClick={handleCloseModal}>
                            <Close />
                        </IconButton>
                    </Modal.Header>
                    <Modal.Body>
                        <FormAssignDoc
                            onSubmit={handleUpdateRoomDoctor}
                            doctorDetail={doctorDetail}
                            handleCancel={handleCloseModal}
                            initialValueFormDoc={initialValueFormDoc}
                        />
                    </Modal.Body>
                </Modal>
            </Grid>
        </Grid>
    );
}
